import { render } from "./ordentrabajoresultadoconguiaec.vue?vue&type=template&id=6285b9e4&scoped=true"
import script from "./ordentrabajoresultadoconguiaec.vue?vue&type=script&lang=js"
export * from "./ordentrabajoresultadoconguiaec.vue?vue&type=script&lang=js"

import "./ordentrabajoresultadoconguiaec.vue?vue&type=style&index=0&id=6285b9e4&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6285b9e4"]])

export default __exports__